module.exports = __webpack_public_path__ + "img/redditt.30538c01.svg";